import { BannerAlert, Modal, Typography } from "@trustpilot/businessapp-patternlibrary";
import { Text } from "ilenia";
import { useState } from "react";

import { StyledBannerAlert, StyledParagraph } from "./styled";
import { UnpaidInvoiceMessagesProps } from "./types";

const UnpaidInvoiceMessages: React.FC<UnpaidInvoiceMessagesProps> = ({ unpaidInvoiceInfo, billingInfo }) => {
  const { missedPaymentStatus } = unpaidInvoiceInfo;
  const isDowngraded = billingInfo?.payment_status?.startsWith("DOWNGRADED");
  const [isOpen, setIsOpen] = useState<boolean>(missedPaymentStatus === "critical" && isDowngraded);

  const [isBannerVisible, setIsBannerVisible] = useState(true);

  const onClose = () => {
    setIsOpen(false);
  };

  const onBannerClose = () => {
    setIsBannerVisible(false);
  };

  const interpolations = {
    INVOICE_ID: unpaidInvoiceInfo.invoiceNumber,
    DAYS_LEFT: unpaidInvoiceInfo.daysLeft,
    ACCOUNTING_EMAIL: unpaidInvoiceInfo.accountingEmail,
  };

  if (!["warning", "critical"].includes(missedPaymentStatus)) {
    return null;
  }

  return missedPaymentStatus === "critical" && isDowngraded ? (
    <Modal
      isOpen={isOpen}
      header={<Text id={`unpaidInvoiceInfo.${unpaidInvoiceInfo.missedPaymentStatus}.header`} />}
      mainActionButton={{
        buttonText: <Text id={`unpaidInvoiceInfo.${missedPaymentStatus}.buttonText`} />,
        onClick: onClose,
      }}
      onClose={onClose}
    >
      <>
        <StyledParagraph>
          <Typography variant="body-l" as="p">
            <Text id={`unpaidInvoiceInfo.${missedPaymentStatus}.paragraph1`} interpolations={interpolations} />
          </Typography>
        </StyledParagraph>
        <StyledParagraph>
          <Typography variant="body-l" as="p">
            <Text id={`unpaidInvoiceInfo.${missedPaymentStatus}.paragraph2`} interpolations={interpolations} />
          </Typography>
        </StyledParagraph>
        <StyledParagraph>
          <Typography variant="body-l" as="p">
            <Text id={`unpaidInvoiceInfo.${missedPaymentStatus}.paragraph3`} interpolations={interpolations} />
          </Typography>
        </StyledParagraph>
      </>
    </Modal>
  ) : (
    isBannerVisible && (
      <StyledBannerAlert>
        <BannerAlert
          appearance={missedPaymentStatus === "warning" ? "warning" : "critical"}
          closable
          onClose={onBannerClose}
        >
          <Text id={"unpaidInvoiceInfo.warning.bannerAlert"} interpolations={interpolations} />
        </BannerAlert>
      </StyledBannerAlert>
    )
  );
};

export default UnpaidInvoiceMessages;
